import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations } from './translations';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lyomas_lang') || 'en');

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.body.className = lang === 'ar' ? 'arabic-font' : '';
    localStorage.setItem('lyomas_lang', lang);
  }, [lang]);

  const t = useCallback((key) => {
    const parts = key.split('.');
    let v = translations[lang];
    for (const p of parts) {
      v = v?.[p];
      if (v === undefined) break;
    }
    if (v === undefined) {
      // fallback to english
      let fb = translations.en;
      for (const p of parts) {
        fb = fb?.[p];
        if (fb === undefined) break;
      }
      return fb ?? key;
    }
    return v;
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === 'en' ? 'ar' : 'en'));

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t, isRTL: lang === 'ar' }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside LangProvider');
  return ctx;
};
